import { useContext } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';

const TopMembersAlumniTable = () => {
    const { state } = useContext(SmartContext);
    const members = state.data.topMembersAlumni;

    return (
        <div className="bg-white custom-shadow h-100 radius-6 overflow-hidden">
            <div className="p-4 pb-0">
                <h5 className="col font-18 font-600 mb-3">Most Outreached Alumni</h5>
            </div>
            {members.length === 0 ? (
                <p className="font-14 text-gray-64 px-4 pb-4">No alumni member data available.</p>
            ) : (
                <div className="x-scroll p-0 m-0">
                    <table className="alumni-table table table-hover mb-0" style={{ minWidth: '1140px' }}>
                        <thead>
                            <tr>
                                <th style={{ width: '350px' }}>Alumni Name</th>
                                <th>Program</th>
                                <th>Batch Year</th>
                                <th>Total Logs</th>
                                <th>Teams Engaged</th>
                            </tr>
                        </thead>
                        <tbody>
                            {members.map((member: any, index: number) => (
                                <tr key={index}>
                                    <td>
                                        <span className="name-bold"><a href={`${process.env.REACT_APP_APP_BASE_URL}/alumni/${member.id}/profile`} target='_blank'>{member.name}</a></span>
                                    </td>
                                    <td>
                                        <span className="batch">{member.program}</span>
                                    </td>
                                    <td>
                                        <span className="batch">{member.batchYear}</span>
                                    </td>
                                    <td>
                                        <span className="log-badge">{member.totalLogs}</span>
                                    </td>
                                    <td>
                                        <span className="teams">{member.teamsEngaged} teams</span>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default TopMembersAlumniTable;
